function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "298.658 85.505 51.9 56.2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.041621, -55.295268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361,152.1h-27.1c-0.6-2.4-2.8-4.2-5.4-4.2h-6.8v-5.7c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4v5.9 c-2.4,0.6-4.2,2.8-4.2,5.4v4.2v33.7c0,3.1,2.5,5.6,5.6,5.6h8.2H361c3.1,0,5.6-2.5,5.6-5.6v-33.7 C366.6,154.6,364.1,152.1,361,152.1z M363.8,191.4c0,1.5-1.2,2.8-2.8,2.8h-27.6c0.5-0.8,0.7-1.8,0.7-2.8V155H361 c1.5,0,2.8,1.2,2.8,2.8V191.4z M317.6,191.4v-33.7v-4.2c0-1.5,1.2-2.8,2.8-2.8h8.2c1.5,0,2.8,1.2,2.8,2.8v37.8 c0,1.5-1.2,2.8-2.8,2.8h-8.2C318.8,194.1,317.6,192.9,317.6,191.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.5,158.8h-19.7c-0.8,0-1.4,0.6-1.4,1.4v6.8c0,0.8,0.6,1.4,1.4,1.4h19.7c0.8,0,1.4-0.6,1.4-1.4v-6.8 C359.9,159.4,359.3,158.8,358.5,158.8z M357.1,165.5h-16.9v-3.9h16.9V165.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.1,
    cy: 174.2,
    r: 2.6,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.7,
    cy: 174.2,
    r: 2.6,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.2,
    cy: 174.2,
    r: 2.6,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.1,
    cy: 180.6,
    r: 2.6,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.7,
    cy: 180.6,
    r: 2.6,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.2,
    cy: 180.6,
    r: 2.6,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.1,
    cy: 187,
    r: 2.6,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.7,
    cy: 187,
    r: 2.6,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.2,
    cy: 187,
    r: 2.6,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f3168aca66c117acddd53d2cf620eb97.svg";
export { ForwardRef as ReactComponent };